import {DOWNLOAD_FILE_STATUS_MESSAGES} from "./ConfigConstants";
const AmazonS3URI = require('amazon-s3-uri');

export function getS3Uri(s3Bucket: string, s3Key:any) {
    return `https://s3.amazonaws.com/${s3Bucket}/${s3Key}`;
}

/**
 * This method should be used to parse the S3 URI stored in the Shipping Request/Pkg entity into Bucket and Key.
 * @param s3Uri
 */
export function parseS3Uri(s3Uri: string) {
    try {
        const uri  = decodeURI(s3Uri);
        const s3PathTokens = uri.split("/");
        const fileNameAndVersionId = s3PathTokens[s3PathTokens.length-1].split("?");

        return {
            bucket: AmazonS3URI(s3Uri).bucket,
            /**
             * In S3 key, we usually have the entire path from the root of S3 bucket for a file.
             * Hence, we are splitting the s3 key using `/` and then taking the last token.
             * From that last token, we are extracting filename by splitting on `?` the filename & versionId
             */
            key: fileNameAndVersionId[0]
        }
    } catch (err) {
        console.warn(`${s3Uri} is not a valid S3 uri`) // should not happen because portal should always return valid URL
        throw err;
    }
}

export const handleFileDownload = async (s3Uri: string | undefined,
                                         preSignedUrlQuery: (arg0: string) => (PromiseLike<{ s3PreSignedUrl: any }> | { s3PreSignedUrl: any }),
                                         onDownloadFailedErrorMessage: string) => {
    try {
        if (s3Uri) {
            const { s3PreSignedUrl }  = await preSignedUrlQuery(s3Uri);
            window.open(s3PreSignedUrl, '_blank');
        } else {
            throw DOWNLOAD_FILE_STATUS_MESSAGES.NO_S3URI_MESSAGE;
        }
    } catch (e) {
        if(e === DOWNLOAD_FILE_STATUS_MESSAGES.NO_S3URI_MESSAGE) {
            throw DOWNLOAD_FILE_STATUS_MESSAGES.NO_S3URI_MESSAGE;
        }
        throw onDownloadFailedErrorMessage;
    }
};